(function (angular) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyToggleClass", [
    "$interpolate",
    function ($interpolate) {
      return {
        restrict: "A",
        link: function (scope, element, attrs) {
          var $tagsInput = element.find("tags-input");
          var $input = element.find("input, textarea");
          var $uiSelect = element.find("ui-select");
          var $label = element.find("label");

          var isTagsInput = !!$tagsInput.length;
          var isInput = !isTagsInput && !!$input.length;
          var isUiSelect = !!$uiSelect.length;

          var $elWithNgModel;

          if (isInput) {
            $elWithNgModel = $input;
          }

          if (isTagsInput) {
            $elWithNgModel = $tagsInput;
          }

          if (isUiSelect) {
            $elWithNgModel = $uiSelect;
          }

          var state = {
            isNotEmpty: null,
            isFocused: null,
            isAutofill: null,
          };

          function animationStart(target) {
            if (target.animationName === "onAutoFillStart" || target.animationName === "onAutoFillCancel") {
              state.isAutofill = target.animationName === "onAutoFillStart";
              repaint();
            }
          }

          $elWithNgModel.get(0).addEventListener("animationstart", animationStart);

          function getNgModelExpression() {
            return $elWithNgModel.attr("ng-model") || $elWithNgModel.attr("data-ng-model");
          }

          function getNgModelValue() {
            return $elWithNgModel.scope().$eval(getNgModelExpression());
          }

          function repaint() {
            var isLabelFloating;
            var isFocused;

            if (isInput || isTagsInput) {
              isLabelFloating = state.isNotEmpty || state.isFocused || state.isAutofill;
              isFocused = state.isFocused;
            }

            if (isUiSelect) {
              isLabelFloating = state.isNotEmpty;
              isFocused = state.isFocused;
            }

            $label.toggleClass("is-label-floating", isLabelFloating);
            element.toggleClass("is-focused", isFocused);
          }

          function refreshIsNotEmpty() {
            if (isInput) {
              state.isNotEmpty = $input.val().length > 0;
            }

            if (isUiSelect) {
              var selectedOption;
              var selectModel;
              var selectValue;

              if (attrs.tyToggleClassUiSelectNgModel) {
                selectModel = scope.$eval(attrs.tyToggleClassUiSelectNgModel);
              }

              selectValue = selectModel ? selectModel : $interpolate(element.find(".ui-select-match").text())(scope);

              selectValue = selectValue || "";
              selectedOption = selectValue.trim();
              state.isNotEmpty = selectedOption.length > 0;
            }

            if (isTagsInput) {
              var $tagsInputTextbox = $tagsInput.find("input");
              var ngModelValue = getNgModelValue();

              var noTextAfterTags = $tagsInputTextbox.length && $tagsInputTextbox.val().length === 0;
              var tagsAreEmpty = ngModelValue && ngModelValue.length === 0;
              var tagsAreUndefined = typeof ngModelValue === "undefined"; // When ng-is-required is false, this can happen when there are no tags

              var isEmpty = noTextAfterTags && (tagsAreEmpty || tagsAreUndefined);

              state.isNotEmpty = !isEmpty;
            }
          }

          if (isInput) {
            $input
              .on("focus", function () {
                state.isFocused = true;
                repaint();
              })
              .on("blur", function () {
                state.isFocused = false;
                repaint();
              });
          }

          if (isUiSelect) {
            element
              .on("ui-select-blur", function () {
                state.isFocused = false;
                repaint();
              })
              .on("ui-select-focus", function () {
                state.isFocused = true;
                repaint();
              });
          }

          if (isInput) {
            $input.on("keyup", function () {
              refreshIsNotEmpty();
              repaint();
            });
          }

          if (isTagsInput) {
            $tagsInput.on("keyup", "input", function () {
              refreshIsNotEmpty();
              repaint();
            });

            $tagsInput
              .on("focus", "input", function () {
                state.isFocused = true;
                repaint();
              })
              .on("blur", "input", function () {
                state.isFocused = false;
                refreshIsNotEmpty();
                repaint();
              });
          }

          var ngModelExpression = getNgModelExpression();
          if (ngModelExpression) {
            $elWithNgModel.scope().$watch(ngModelExpression, function () {
              scope.$evalAsync(() => {
                refreshIsNotEmpty();
                repaint();
              });
            });
          }

          refreshIsNotEmpty();
          state.isFocused = false;
          repaint();
        },
      };
    },
  ]);
})(window.angular);
